import React, { ReactElement, useEffect, useState } from "react";
import {
    useListExternalFormsQuery,
} from "../../../__generated__/api";

import ExternalFormsPicker, { SelectedValue } from "./ExternalFormsPicker";

export interface ExternalFormsProps {
    placeholder?: string;
    className?: string;
    isClearable: boolean;
    value?: string;
    onSelected: (value: string | undefined) => void;
}

export default function ExternalForms({
    onSelected, placeholder, value, className, isClearable,
}: ExternalFormsProps): ReactElement {
    const [selected, setSelected] = useState<string[]>([]);

    return (
        <>
            <ExternalFormsPicker
                isClearable={isClearable}
                value={value}
                selectedValue={selected[0]}
                placeholder={placeholder}
                onSelected={current => {
                    if (!current) {
                        setSelected([]);
                        onSelected(undefined);
                    } else if (current.id !== "") {
                        setSelected([current.id]);
                    }
                }}
            />
            {selected.map((selectedId, index) => (
                <ExternalFormsPicker
                    key={selectedId}
                    isClearable={isClearable}
                    value={value}
                    selectedValue={selected[index - 1]}
                    id={selectedId}
                    className="mt-2"
                    onSelected={current => {
                        const copy = selected ? [...selected] : [];
                        copy.splice(index + 1);

                        if (!current) {
                            onSelected(undefined);
                        } else if (!current.hasChildren) {
                            onSelected(current.id ? current.id : undefined);
                        } else {
                            copy.push(current.id);
                        }
                        setSelected(copy);
                    }}
                />
            ))}
        </>
    );
}

ExternalForms.defaultProps = {

    placeholder: undefined,

    className: "",

    value: undefined,
};
